// extracted by mini-css-extract-plugin
module.exports = {"qixi_share":"inviteSuccess_qixi_share__2TBhJ","load_btn":"inviteSuccess_load_btn__1O4p1","mask":"inviteSuccess_mask__1qGys"};